// @ts-check
/* eslint-disable no-return-assign, react/jsx-one-expression-per-line, sort-imports */
import classNames from "classnames" // eslint-disable-line import/no-unresolved
import Link from "../../../link"
import memo from "set-state-compare/build/memo.js"
import PropTypes from "prop-types"
import React from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import Text from "../../../utils/text"

const dataSets = {}

/**
 * @typedef {object} Props
 * @property {boolean|string} [active]
 * @property {string} [className]
 * @property {string} icon
 * @property {React.ReactNode} [label]
 */
/**
 * @typedef {object} State
 * @property {boolean} hover
 */
export default memo(shapeComponent(/** @augments {ShapeComponent<Props, State>} */ class ComponentsAdminLayoutMenuMenuItem extends ShapeComponent {
  static propTypes = {
    active: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    className: PropTypes.string,
    icon: PropTypes.string.isRequired,
    label: PropTypes.any
  }
  state = {
    hover: false
  }

  setup() {}

  render() {
    const {active, children, className, icon, identifier, label, to, ...restProps} = this.props
    const {hover} = this.s
    const textStyle = {}
    const style = {
      display: "flex",
      width: "80%",
      alignItems: "center",
      paddingTop: 10,
      paddingRight: 14,
      paddingBottom: 10,
      paddingLeft: 14,
      marginLeft: "auto",
      marginRight: "auto"
    }
    const isActive = active === true || active == identifier

    if (isActive || hover) {
      style.background = "#323435"
      style.borderRadius = 7
      textStyle.color = "#b9b9bb"
    } else {
      textStyle.color = "#6f6f71"
    }

    return (
      <Link
        dataSet={dataSets[`menuItem-${isActive}-${className}-${identifier}`] ||= {
          active: isActive,
          class: classNames("components--admin--layout--menu--menu-item", className),
          identifier
        }}
        onPointerEnter={this.tt.onPointerEnter}
        onPointerLeave={this.tt.onPointerLeave}
        style={style}
        to={to || "#"}
        {...restProps}
      >
        <i className={`fa fa-fw fa-${icon} menu-item-icon`} style={{color: textStyle.color, marginRight: 4, fontSize: 12}} />
        {children || <Text style={textStyle}>{label}</Text>}
      </Link>
    )
  }

  onPointerEnter = () => {
    this.s.hover = true
  }

  onPointerLeave = () => {
    this.s.hover = false
  }
}))
